module.exports = __webpack_public_path__ + "static/scale-model-of-columbia-south-carolina-c0dd5899bd6a5e49ec7dec5bcff9d43b.png";